<div
  class="size-full rounded-md border-4 p-4 transition-all"
  [class]="
    appearance() === 'DEFAULT'
      ? solid()
        ? 'border-dashed border-slate-300 bg-white'
        : 'border-dotted border-white bg-white/30'
      : appearance() === 'CORRECT'
        ? solid()
          ? 'border-solid border-emerald-500 bg-emerald-100'
          : 'border-solid border-emerald-500 bg-emerald-500/50'
        : appearance() === 'ALMOST'
          ? solid()
            ? 'border-solid border-orange-500 bg-orange-100'
            : 'border-solid border-orange-500 bg-orange-500/50'
          : solid()
            ? 'border-solid border-red-500 bg-red-100'
            : 'border-solid border-red-500 bg-red-500/50'
  "
>
  <ng-content></ng-content>
</div>
